import { render } from "./LicensesComponent.vue?vue&type=template&id=070e8243"
import script from "./LicensesComponent.vue?vue&type=script&lang=js"
export * from "./LicensesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__